import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(window.location.hash.slice(1)).get('session_id');
    (async () => {
      try {
        const res = await axios.post(`${API}/auth/session`, { session_id: sessionId }, { withCredentials: true });
        setUser(res.data);
        window.history.replaceState(null, '', window.location.pathname);
        navigate('/account', { replace: true, state: { user: res.data } });
      } catch {
        window.history.replaceState(null, '', window.location.pathname);
        navigate('/', { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center gap-4" data-testid="auth-callback-loading">
      <div className="w-12 h-12 border-4 border-[#0288D1] border-t-transparent rounded-full animate-spin" />
      <p className="text-slate-500 font-heading font-semibold">Accesso in corso...</p>
    </div>
  );
}
